
export const binarySearch = (key, {col, getKey = v=>v}) => {
    let from = 0;
    let to = col.length;

    for (;;) {
        if (from === to) {
            return -1 - from; // Not found
        }

        const middleIndex = Math.floor((from + to) / 2);

        const middleKey = getKey(col[middleIndex]);

        if (middleKey === key) {
            return middleIndex;
        } else if (key > middleKey) {
            from = middleIndex + 1;
        } else {
            to = middleIndex;
        }
    }
};


// console.log(binarySearch(0, {col: [1,3,5, 6]}))
// console.log(binarySearch(5, {col: [1,3,5, 6]}))
// console.log(binarySearch(6, {col: [1,3,5, 6]}))
// console.log(binarySearch(7, {col: [1,3,5, 6]}))
// console.log(binarySearch(5, {col: [1,3,5, 6]}))